<script>
import {mapGetters} from "vuex";
import {
    SET_FLOORS,
    SET_JSON_CONFIG_DATA,
    SET_KIOSK,
    SET_MODELS,
    SET_NAMES,
    SET_PORTALS,
    SET_UNITS
} from "./constants/map-commands";
import ICON_PROPS from "./constants/icon-props";

export default {
    name: 'MvDataLayer',
    props:{
        mapData: { type: Object, required: true },
    },
    computed:{
        ...mapGetters(['getFileSrc', 't']),
        mvConfig(){
            return {
                ...this.mapData.config,
                floors: {
                    ...this.mapData.config.floors,
                    ...this.mvConfigFloors
                },
                labels: this.mvConfigLabels
            }
        },
        mvModels(){
            return this.mapData.models.map( m => ({
                ...m,
                files: m.filesSrc || m.files, // TODO: fix terminal(m.files) & manager apps inconsistency(m.filesSrc)
            }))
        },
        mvConfigFloors(){
            return this.mvFloors.reduce((acc,f) => {
                acc[f.unit] = {
                    ..._.get( this.mapData.config, `floors[${f.unit}]`, {}),
                    ...f
                }
                return acc
            },{})
        },
        mvConfigLabels(){
            const visibilityLevels = _.get(this.mapData.config,'visibility_levels', {})
            return this.mapData.objects.reduce( (acc, obj) => {
                if(obj.type === 'label'){

                    const item = {}
                    const icon = this.t(obj, 'icon')
                    if(icon){
                        item.url = this.getIconUrl(icon)
                    }
                    else
                        item.text = this.t(obj,'name')

                    acc.push({
                        id: `${obj.id}--${obj.unit.name}`,
                        where:'unit',
                        fade_distance: visibilityLevels[obj.meta.visibility_level] || false,
                        ...item,
                        ...obj.meta.settings,
                        unit: obj.unit.name,

                    })
                }
                return acc
            }, [])
        },
        mvFloors(){
            return this.mapData.objects.reduce( (acc, obj) => {
                if(obj.type === 'floor'){
                    acc.push({
                        id: obj.id,
                        map_model_id: obj.unit.map_model_id,
                        unit: obj.unit.name,
                        level: obj.meta.level,
                        building_index: obj.meta.building_index,
                        building_group_id: obj.floor.building_group_id,
                        is_outdoor: obj.meta.is_outdoor || false,
                        ...(obj.meta.settings || {}),
                    })
                }
                return acc
            },[])
        },
        mvPortals(){
            return Object.values(
                this.mapData.objects.reduce( (acc, obj) => {
                    if(obj.type !== 'portal') return  acc

                    if(acc[obj.id])
                        acc[obj.id].units.push(obj.unit.name)
                    else
                        acc[obj.id] = {
                            id: obj.id,
                            map_model_id: obj.unit.map_model_id,
                            name: this.t(obj,'name'),
                            portal_type: obj.meta.portal_type,
                            direction: obj.meta.portal_direction,
                            active: obj.meta.active || false,
                            anchor: obj.meta.anchor || false,
                            dont_show_step: obj.meta.dont_show_step || false,
                            custom_message: obj.meta.custom_message || null,
                            target_zone: obj.lists.target_zone || null,
                            units: [obj.unit.name],
                            ...(obj.meta.settings || {}),
                        }
                    return acc
                },{})
            )
        },
        mvUnits(){
            return this.mapData.units.map(u => ({
                map_model_id: u.map_model_id,
                unit: u.name,
                floor: u.floor.unit_name
            }))
        },

        mvObjects(){
            return this.mapData.objects.reduce((acc, obj) => {
                if(!['tenant','service','terminal'].includes(obj.type)) return  acc;

                const preferredPortals =
                    obj.lists.target_zone ?
                        this.mvPortals.reduce( (accc, portal) => {
                            // prefer to us portals for same TZ
                            portal.target_zone === obj.lists.target_zone && accc.push(portal.id);
                            return accc;
                        }, []) : [];
                const iconData = this.getIconData(obj, obj.unit.name, 'icon');

                const o = {
                    id: obj.id,
                    map_model_id: obj.unit.map_model_id,
                    unit: obj.unit.name,
                    name: this.t(obj, 'name'),
                    anchor: obj.meta.anchor || false,
                    active: obj.meta.active,
                    landmark: this.t(obj, 'landmark', false),
                    type: obj.type,
                    floor: obj.floor.unit_name,
                    destination_step_message: this.t(obj, 'destination_step_message'),
                    destination_step_icon: obj.files.destination_step_icon,
                    icon: obj.meta.is_map_icon_hidden ? null : iconData,
                    show_tenant_name_in_map: obj.meta.show_tenant_name_in_map || false,
                    target_zone: obj.lists.target_zone,
                    preferred_portals: preferredPortals,
                    can_pass_through: Boolean(obj.meta.can_pass_through),
                    ...iconData,

                }
                /*
                this.getFilters(filterHook).forEach( f => f(o) )
                if(!o.isDeletedByFilter)
              */
                acc.push(o)
                return acc
            },[])
        },
    },
    inject:['mapViewer'],

    mounted(){
        this.initViewer()

    },
    methods:{
        initViewer(){
            this.setModels()
            this.setFloors()
            this.setNames()
            this.setUnits()
            this.setPortals()
            this.setMapConfig()
            this.setKiosk()
        },
        getIconUrl(url){
            let newUrl = typeof url === 'string' ? url : this.getFileSrc(url)
            if(!url) return null
            newUrl = newUrl.replace(/(.*)\/maps\/.*\/(.*)\.svg$/, '$1/temp-png/$2.png')
            newUrl += '?mode=texture'
            return  newUrl
        },
        getIconData (object, unitName, fileSlug = 'icon') {
            const result = {}

            const icon = this.t(object, fileSlug)
            result.url = this.getIconUrl(icon)
            if(!result.url) return

            const iconData = _.get(object.meta, `icons[${object.unit.name}]`, object.meta)

            /*
                if (iconData.custom_icon_position)
                result.position = {
                    x: iconData.icon_position_x,
                    y: iconData.icon_position_y,
                    z: iconData.icon_position_z,
                }*/

            if (iconData.custom_icon_position)
                result.position_offset = {
                    x: iconData.icon_position_x,
                    y: iconData.icon_position_y,
                    z: iconData.icon_position_z,
                }

            const def = {};
            const selected = {};

            ICON_PROPS.forEach(p => { if(iconData[p]) result[p] = iconData[p]; })

            return result
        },

        // Data supply commands
        setModels() {
            if(!this.mapViewer.listenEvents) return
            this.mapViewer.sendMapCommand(SET_MODELS, this.mvModels)
        },
        setFloors() {
            if(!this.mapViewer.listenEvents) return
            this.mapViewer.sendMapCommand(SET_FLOORS, this.mvFloors);
        },
        setNames() {
            if(!this.mapViewer.listenEvents) return
            this.mapViewer.sendMapCommand(SET_NAMES, this.mvObjects);
        },
        setUnits() {
            if(!this.mapViewer.listenEvents) return
            this.mapViewer.sendMapCommand(SET_UNITS, this.mvUnits);
        },
        setPortals(){
            if(!this.mapViewer.listenEvents) return
            this.mapViewer.sendMapCommand(SET_PORTALS, this.mvPortals);
        },
        setMapConfig(){
            if(!this.mapViewer.listenEvents) return
            this.mapViewer.sendMapCommand(SET_JSON_CONFIG_DATA, this.mvConfig);
        },
        setKiosk(){
            if(this.mapData.terminalUnitName)
                this.mapViewer.sendMapCommand(SET_KIOSK, {
                    unit: this.mapData.terminalUnitName,
                });
        },
    },
    watch:{
        mvConfig: {
            handler() {
                if(this.mapViewer.isReactive)
                    this.setMapConfig()
            },
        },
        mvObjects: {
            handler() {
                if(this.mapViewer.isReactive)
                    this.setNames()
            },
        },
        'mapData.config.cameras'(config){
            const conf = JSON.parse(JSON.stringify(config));
            this.mapViewer.viewApi && this.mapViewer.viewApi.config.from_json(conf);
        },
    },
    render(){ return null }
}
</script>

